"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_SEARCH_CLASSES = exports.HEADER_SEARCH_IDS = void 0;
exports.HEADER_SEARCH_IDS = {
    FORM: 'js-header-search-product-form',
    TOGGLE_OPTION_BUTTON: 'js-header-option-toggle-button',
    OPTIONS: 'js-header-search-options',
    WARNING_OPTIONS: 'js-header-search-warning-options',
    LASER_OPTIONS: 'js-header-search-laser-options',
    LASER_SUB_OPTIONS: 'js-header-search-laser-sub-options',
    SEARCH_BUTTON: 'js-header-search-button',
    PRODUCT_TYPE_ANNOTATION: 'js-header-product-type-annotation',
    CHILD_SYMBOL_MARK: 'js-header-child-symbol-mark',
    CHILD_SYMBOL_MARK_ARROW: 'js-header-child-symbol-mark-arrow',
    WARNING_HAZARD_CHILD: 'js-child-symbol-mark',
    RESET_BUTTON: 'js-header-search-reset-button',
    LASER_CLASS_RANKS_CONTAINER: 'js-header-laser-class-ranks-container',
    LASER_TYPES_CONTAINER: 'js-header-laser-types-container',
    LASER_WAVELENGTH_CONTAINER: 'js-header-laser-wave-length-container',
    LASER_BUTTON: 'product_type_1',
};
exports.HEADER_SEARCH_CLASSES = {
    BUTTON_DISABLED: 'button-disabled',
};
